/**
 * Comprueba si el usuario tiene todos los permisos requeridos.
 *
 * P-10: un usuario con `separacion.ver_propias` NO debe poder acceder a
 * `separacion.ver_todas`; con la lista completa del SUPERADMIN debe poder todo.
 *
 * @param permisosPermitidos Permisos resueltos del usuario (vienen de `user.permissions`).
 * @param requeridos Uno o más permisos que se exigen; todos deben estar presentes.
 */
export function can(
  permisosPermitidos: readonly string[] | undefined,
  ...requeridos: string[]
): boolean {
  if (!requeridos || requeridos.length === 0) {
    return true;
  }
  if (!permisosPermitidos || permisosPermitidos.length === 0) {
    return false;
  }
  return requeridos.every((requerido) => permisosPermitidos.includes(requerido));
}